var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "eu-pa_3 eu-pa_5_md" },
    [
      _vm._l(_vm.items, function (item, index) {
        return _c("div", { key: index, staticClass: "eu-flex eu-pb_5" }, [
          _c(
            "span",
            {
              staticClass:
                "summary-title eu-flex-item eu-basis_12 eu-basis_12_md eu-pb_3",
            },
            [_vm._v(_vm._s(item.name || "Item " + (index + 1)))]
          ),
          _c(
            "span",
            {
              staticClass:
                "summary-label eu-flex-item eu-basis_12 eu-basis_12_md",
            },
            [
              _vm._v(_vm._s(_vm.itemAmountToCurrency(item.amount)) + " "),
              _c("span", { staticClass: "summary-content" }, [
                _vm._v("(x " + _vm._s(item.default_quantity) + " und.)"),
              ]),
            ]
          ),
        ])
      }),
      _c("div", { staticClass: "eu-flex eu-justify_begin" }, [
        _c("span", { staticClass: "info-label eu-flex-item" }, [
          _vm._v(_vm._s(_vm.$t("itemsLabel"))),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }